var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Camp-White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camp-White",
    clipPath: "url(#clip-Camp-White)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Camp-Black",
    d: "M25.451,17.445l1.009-1.009a1.4,1.4,0,0,0,0-1.977l-.028-.028a1.4,1.4,0,0,0-1.977,0l-4.01,4.01L8.43,6.425l4.01-4.01a1.4,1.4,0,0,0,0-1.977L12.412.41a1.4,1.4,0,0,0-1.977,0L9.425,1.42,8.416.41a1.413,1.413,0,0,0-1.991,0l-2,2L3.411,1.406a1.418,1.418,0,0,0-2,2L2.415,4.42l-2,2A1.4,1.4,0,0,0,.41,8.4L1.42,9.411.41,10.435a1.4,1.4,0,0,0,0,1.977l.028.028a1.4,1.4,0,0,0,1.977,0l4.01-4.01L18.441,20.446l-4.01,4.01a1.4,1.4,0,0,0,0,1.977l.028.028a1.4,1.4,0,0,0,1.977,0l1.009-1.009,1.009,1.009a1.4,1.4,0,0,0,1.977,0l2-2,1.009,1.009a1.418,1.418,0,0,0,2-2l-1.009-1.009,2.019-2.005a1.4,1.4,0,0,0,0-1.977Z",
    transform: "translate(4.565 4.565)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampWhite);
export default __webpack_public_path__ + "static/media/Camp-White.61967968f80c764e7575f9a20cc20542.svg";
export { ForwardRef as ReactComponent };